'use client';

export { default } from './Container';
export { default as containerClasses } from './containerClasses';
export * from './containerClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Container/index.js
// module id = 833
// module chunks = 22